import { ICustomLookupColumn, ICustomLookupOptions, ICustomSearchScreenDialogStyle } from '../constants';

const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'PurchaseOrder',
        caption: 'Purchase order',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: true,
    },
    {
        dataField: 'LineNumber',
        caption: 'Line',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: true,
    },
    {
        dataField: 'DateDue',
        caption: 'Due',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'Product',
        caption: 'Product',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'OnOrder',
        caption: 'On order',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'OnTransit',
        caption: 'In transit',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    },
];

const SEARCH_SCREEN_DIALOG_STYLE: ICustomSearchScreenDialogStyle = {
    width: 892,
    maxWidth: 892,
    height: 495,
    maxHeight: 495
};

export const productPurchaseOrderLineLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details'
};
